/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
    function updateATCPrice(){
        setTimeout(function(){

      let bundlePrice = document.querySelector('kaching-bundle .kaching-bundles__bar--selected .kaching-bundles__bar-price');
      console.log(bundlePrice);
      let atcPrice = document.querySelector('.price-new-wrap .price-atc-wrap');
      if(bundlePrice && atcPrice){
        atcPrice.textContent = bundlePrice.textContent;
      }
       }, 3000);
    }
    updateATCPrice();
  });
// Insert any custom theme js here...
